import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useCustomSearchParams from "../../../utils/useCustomSearchParams.js";
import { toast } from "react-toastify";
import ICONS from "../../../assets/Icons/index.js";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";

import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import CommonTransactionApprovalCard from "../../../components/_utils/CommonTransactionApprovalCard/index.jsx";
import FormatAmount from "../../../components/_utils/FormatAmount/FormatAmount.js";
import PaginationComponent from "../../../components/_utils/PaginationComponent/index.jsx";

import Loader from "../../../components/Loader/Index.jsx";
import { getAllCategories } from "../../../redux/features/sharedResources/sharedResources.js";
import { checkUsertoken } from "../../../redux/features/login/login.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";

import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
  RejectReasonLength,
} from "../../../utils/configurationProvider.js";

import CommonToast from "../../../components/_utils/CommonToast/index.jsx";

import SmallPopupWithInput from "../../../components/_utils/CommonSmallPopupWithInput/index.jsx";
import TEXT from "../../../utils/globalText.js";

import { removeNewLabelRequest } from "../../../redux/features/reimbursementRequest/index.js";
import UniversalRefreshToast from "../../../components/_utils/UniversalRefreshToast/index.jsx";
import {
  approveFieldForceRequest,
  getAllFieldForceRequest,
  getSpecificFieldForceRequest,
  addFieldForceLabelRequest,
  fieldForceRequestDeniedApproval,
} from "../../../redux/features/fieldForceRequest/index.js";
import FieldForceReqTxnDetailsPopup from "../../../components/FieldForceRequestTransactionComp/FieldForceReqTxnDetailPopup/index.jsx";
import FieldForceAccountDetailsPopup from "../../../components/_utils/FieldForceAccountDetailsPopup/index.jsx";
import UseHandleScroll from "../../../hooks/useHandleScroll.js";

const DeclinedRed = ICONS.REJECTED_RED;
const FailedToAction = ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE;

const FieldForceRequestSingleApproval = () => {
  const dispatch = useDispatch();
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const location = useLocation();
  const { searchParam, handleSearchParams } = useCustomSearchParams({
    pageno: GlobalConfiguration.lengthCheckOne,
    pagesize: dropdownOptions[GlobalConfiguration.lengthCheckZero],
  });

  const [page, setPage] = useState(
    Number(searchParam.get("pageno")) || GlobalConfiguration.lengthCheckOne,
  );
  const labelActionDispatchedRef = useRef(false);
  const [showPopup, setShowPopup] = useState(false);
  const [deniedId, SetdeniedId] = useState(null);
  const [declineReason, setDeclineReason] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [doneBinding, setDoneBinding] = useState(false);
  const [loading, setLoading] = useState({});
  const [openRequestpopup, setopenRequestpopup] = useState(false);
  const [currentAccountDetails, setcurrentAccountDetails] = useState({
    bankAccountName: "",
    beneAccountId: "",
    bankAccountIFSC: "",
    bankAccountNo: "",
    categories: "",
    requested_amount: "",
    settleType: "",
    bankLogo: "",
    pan: "",
    ownerId: null,
    ownerAccountName: "",
    ownerBankIFSC: null,
    ownerBankBalance: GlobalConfiguration.lengthCheckZero,
    ownerBankLogo: null,
    ownerLastUpdated: null,
    ownerBankAccountNo: null,
    selectedCategory: null,
    mergeCategory: null,
    amountInWords: "",
    labels: [],
    ownerLabels: [],
    comment: "",
    date: "",
    expenseType: "",
    description: "",
    uploadFile: "",
  });
  const Navigate = useNavigate();
  const [isDrawerOpen, setisDrawerOpen] = useState(false);
  const [BeneTxnDetailsId, SetBeneTxnDetailsId] = useState("");
  const [inputDisabled, setInputDisabled] = useState(false);
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );
  const [AllReimburseTxnAccounts, setAllReimburseTxnAccounts] = useState([]);
  const [allBeneTxnAccountsLoading, setAllBeneTxnAccountsLoading] =
    useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [filterCat, setFilterCat] = useState(false);
  const [initCategory, setInitCategory] = useState("");
  const [label, setlabel] = useState(searchParam.get("category") || "");
  const [showTxnDetailPop, setShowTxnDetailPop] = useState(false);
  const [currentCategory, setCurrentCategory] = useState(
    searchParam.get("category_id") || "",
  );
  const [displayCategory, setDisplayCategory] = useState(
    searchParam.get("dispCat") || "",
  );
  const filterRef = useRef(null);
  const filterBGRef = useRef(null);
  const filterParentDivRef = useRef(null);

  const [mainData, setMainData] = useState([]);

  const [isLabelPopupOpen, setisLabelPopupOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [filteredData, setfilteredData] = useState([]);
  const [txnlabels, settxnLabels] = useState([]);
  const [labeltxnid, setLabeltxnid] = useState([]);
  const [selectedLabels, setSelectedLabels] = useState([]);
  const [RequestId, setRequestId] = useState("");
  const [showSearchBar, setShowSearchBar] = useState(false);
  const cardRefs = useRef({});
  const [timelineTxnDetails, setTimelineTxnDetails] = useState([]);

  // FilteredSearchField states
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [showApprovalTimeline, setShowApprovalTimeline] = useState(false);

  const [currentBtnClicked, setCurrentBtnClicked] = useState({});

  const { ownerAccBalanceLoading, ownerAccBalanceError } = useSelector(
    (state) => state.ownerAllVerification,
  );
  const navigate = useNavigate();
  const [opentimelinepopup, SetopenTimelinePopup] = useState(false);
  const [openApprovalTimeline, setOpenApprovalTimeline] = useState([]);

  const { reimbursementRequestApprovalData } = useSelector(
    (state) => state.reimbursementRequest,
  );
  const services = useSelector((state) => state.refreshToken.services);

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const lastScrollTop = useRef(GlobalConfiguration.lengthCheckZero);
  const [direction, setDirection] = useState("");

  const { handleScroll } = UseHandleScroll(
    setDirection,
    lastScrollTop,
    GlobalConfiguration.singleReqApprovalTxnCardHeight,
  );

  const handleInputChange = (event) => {
    const value = event.target.value;

    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");

    const limitedValue = sanitizedValue.slice(
      GlobalConfiguration.lengthCheckZero,
      RejectReasonLength.lengthOfDecline,
    );

    setDeclineReason(limitedValue);
  };

  const showLoadingToast = (txt) => {
    CommonToast({
      text: txt,
      icon: ICONS?.LOADER_GIF,
      variant: "var(--processing)",
      buttonNeeded: false,
      btnProps: {
        enabledBgColor: "var(--primary-bg)",
        enabledTextColor: "var(--text-primary)",
        btnText: "",
        handleFunction: () => {},
        icon: "",
        btnType: "button",
        isDisabled: false,
        hoverOption: "white",
      },
    });
  };

  const handleReject = async (id, reason) => {
    if (showLoader) return;
    try {
      if (
        services?.find((service) => service === "AFieldForceRequest") ===
        undefined
      ) {
        Navigate("/feature_not_assigned", {
          state: { unavailableService: "AFieldForceRequest" },
        });
        return;
      }

      if (!sessionStorage.getItem("q2p_token")) {
        dispatch(checkUsertoken());
        return;
      }

      setShowLoader(true);
      setInputDisabled(true);

      dispatch(checkUsertoken());
      showLoadingToast("Rejecting request.");

      const result = await dispatch(
        fieldForceRequestDeniedApproval({
          id,
          AccountIdData: declineReason,
        }),
      );

      const payload = result?.payload;

      await new Promise((resolve) =>
        setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
      );

      if (payload?.errors?.user_unauthorized?.[0]) {
        Navigate("/feature_not_assigned", {
          state: { unavailableService: "AFieldForceRequest" },
        });
        return;
      }

      const updatedData = AllReimburseTxnAccounts.map((item) => {
        if (item.request_id !== id) return item;

        const tx = payload?.requests?.[0];
        let lifecycleStatus = "error";
        let errorMessage = "";

        if (payload?.status === true) {
          lifecycleStatus =
            tx?.lifecycle_status === "rejected"
              ? "rejected"
              : tx?.lifecycle_status === "pending"
                ? "pendingOne"
                : "error";
        }

        if (payload?.errors?.base?.[0]?.errors) {
          errorMessage = payload.errors.base[0].errors[0];
        } else if (payload?.errors?.base?.[0]) {
          errorMessage = payload.errors.base[0];
        }

        return {
          ...item,
          lifecycle_status:
            item.lifecycle_status === "pending" && payload?.status === true
              ? lifecycleStatus
              : "error",
          rejected: true,
          rejection_reason: reason,
          error: payload?.status === false ? "true" : "false",
          message: payload?.status === false ? errorMessage : "",
        };
      });

      updateAllTxn(updatedData);

      if (payload?.status === false) {
        CommonToast({
          text:
            payload?.errors?.base?.[0]?.errors?.[0] ||
            payload?.errors?.base?.[0] ||
            "Error occurred",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        setDeclineReason("");
      } else {
        CommonToast({
          text: "Request rejected successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });

        setShowPopup(false);
        setDeclineReason("");
      }
    } catch (error) {
      console.error("Reject txn failed:", error);

      CommonToast({
        text: "Something went wrong. Please try again.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    } finally {
      setShowLoader(false);
      setInputDisabled(false);
      setCurrentBtnClicked((c) => {
        return {
          ...c,
          [id]: "none",
        };
      });
    }
  };

  const fetchSearchDropdownData = async () => {
    setLoadingData(true);

    if (active === "Category") {
      const res = await dispatch(
        getAllCategories({ search_string: searchUserTextDebounce }),
      );

      const categories = res?.payload?.categories || [];

      setInputData(
        categories.map((c) => ({
          id: c.id,
          Category: c.name,
          Description: c.description || "Not given",
        })),
      );
    }
    setTimeout(() => {
      setLoadingData(false);
    });
  };

  const handleClearFilters = () => {
    setCurrentCategory("");
    setDisplayCategory("");
    setSearchUserTextDebounce("");
    setSelectedLabels([]);
    setlabel("");
    setPage(GlobalConfiguration.lengthCheckOne);
    navigate(
      {
        pathname: location.pathname,
        search: `?pageno=${GlobalConfiguration.lengthCheckOne}&pagesize=${dropdownOptions[0]}`,
      },
      { replace: true },
    );
  };

  useEffect(() => {
    if (active) fetchSearchDropdownData();
  }, [active]);

  useEffect(() => {
    // dispatch(getRefreshTokenNew());
    onMount();
  }, [page, pageSize, currentCategory, markerData]);

  useEffect(() => {
    if (isLabelPopupOpen) {
      const availableLabels = JSON.parse(
        sessionStorage.getItem("AvailableLabelsRequest") || "[]",
      );
      settxnLabels(availableLabels);
    }
  }, [isLabelPopupOpen]);

  const onMount = () => {
    setAllBeneTxnAccountsLoading(true);
    dispatch(checkUsertoken());
    // dispatch(getRefreshTokenNew());
    dispatch(
      approveFieldForceRequest({
        page_no: page,
        page_size: pageSize,
        ...(currentCategory && {
          category_id: currentCategory,
        }),
      }),
    )
      .then((response) => {
        const newData = (response?.payload?.requests || []).map((account) => ({
          ...account,
          loading: false,
          error: "false",
          message: "",
          last_updated_user_id_check: "false",
          distribution_lifecycle_status: "",
        }));

        setAllReimburseTxnAccounts(newData);
        setMainData(response?.payload);
        setfilteredData(response?.payload?.requests ?? []);
        setAllBeneTxnAccountsLoading(false);
      })

      .catch(() => {
        setAllBeneTxnAccountsLoading(false);
      });
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  const handleClose = () => {
    setisLabelPopupOpen(false);
    if (labelActionDispatchedRef.current) {
      onMount();
      dispatch(getAllFieldForceRequest());
      labelActionDispatchedRef.current = false;
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setAllBeneTxnAccountsLoading(true);
    dispatch(checkUsertoken());
    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(labeltxnid);
    const res = await dispatch(
      addFieldForceLabelRequest({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );
    if (addFieldForceLabelRequest.fulfilled.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await onMount();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (addFieldForceLabelRequest.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setAllBeneTxnAccountsLoading(false);
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setAllBeneTxnAccountsLoading(true);
    dispatch(checkUsertoken());
    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labeltxnid);
    const res = await dispatch(
      removeNewLabelRequest({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    if (removeNewLabelRequest.fulfilled.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await onMount();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (removeNewLabelRequest.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setAllBeneTxnAccountsLoading(false);
    if (removeNewLabelRequest?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleOpenPopup = (id) => {
    setShowPopup(true);
    SetdeniedId(id);
  };
  const handleClosePopup = () => {
    setShowPopup(false);
    setDeclineReason("");
  };

  const openBeneTxnDetailModal = () => {
    setShowTxnDetailPop(true);
  };

  const handlePagination = (pageNum) => {
    setDirection("");
    setPage(pageNum);
    handleSearchParams("pageno", pageNum);
  };

  const closeBeneTxnDetailModal = () => {
    setShowTxnDetailPop(false);
  };
  const closeBeneAccountDetailModal = () => {
    setisDrawerOpen(false);
  };

  const handleMultiViewClick = () => {
    CommonToast({
      text: "Feature coming soon",
      icon: ICONS?.INFO,
      variant: "var(--coming-soon)",
      buttonNeeded: false,
    });
  };

  const SideDrawerOpen = async (id, txnId) => {
    SetBeneTxnDetailsId(id);
    setisDrawerOpen(!isDrawerOpen);
  };

  const PopupcloseIcons = () => {
    SetopenTimelinePopup(false);
    setShowApprovalTimeline(false);
  };

  const handleApprovalTimeline = (index) => {
    setOpenApprovalTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });

    if (!openApprovalTimeline[index]) {
      setTimeout(() => {
        cardRefs.current[index]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, IntervalConfiguration.intervalExtraSmall);
    }
  };

  const renderApprovalData = (obj) => {
    return Object.keys(obj).map((key, index, array) => {
      const isLastItem =
        index === array.length - GlobalConfiguration?.lengthCheckZero;
      if (key !== "action") {
        return (
          <>
            <div
              key={key}
              className={`flex flex-row items-center ${
                !isLastItem ? "mb-margin-md" : ""
              }`}
            >
              <div className="w-icon-xs border-b-border border-solid border-text-secondary"></div>

              <p
                key={key}
                className="w-width-full text-text-secondary text-sm text-left font-normal ml-margin-xs make-first-letter-small break-words"
              >{`"${key}": "${obj[key]}"`}</p>
            </div>
          </>
        );
      }
      return null;
    });
  };

  const updateAllTxn = (updatedTxn) => {
    setAllReimburseTxnAccounts(updatedTxn);
  };

  const handleFilterCategory = () => {
    setCurrentCategory(label);
    setAllReimburseTxnAccounts([]);
    if (page === GlobalConfiguration.lengthCheckOne) {
      setAllBeneTxnAccountsLoading(true);
    }

    setInitCategory(false);
    setFilterOpen(false);
    setFilterCat(false);
  };
  const handleSelect = (value) => {
    setSelectedValue(value);
    setPageSize(value);
    const nextPage = Number(page) || GlobalConfiguration.lengthCheckOne;
    setPage(nextPage);
    handleSearchParams("pagesize", value);
    handleSearchParams("pageno", nextPage);
  };

  const hasAnyFilter =
    (currentCategory &&
      currentCategory.length > GlobalConfiguration.lengthCheckZero) ||
    (searchUserTextDebounce &&
      searchUserTextDebounce.length > GlobalConfiguration.lengthCheckZero);

  const noTransactionsFromAPI =
    !allBeneTxnAccountsLoading &&
    mainData &&
    mainData.total_count === GlobalConfiguration.lengthCheckZero &&
    !hasAnyFilter;

  const noResultsAfterFilter =
    !allBeneTxnAccountsLoading &&
    AllReimburseTxnAccounts.length === GlobalConfiguration.lengthCheckZero &&
    hasAnyFilter;

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && filterOpen) {
        handleFilterCategory();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [label, selectedLabels, filterOpen]);

  useEffect(() => {
    const handleFilter = (e) => {
      if (
        filterBGRef.current &&
        filterBGRef.current.contains(e.target) &&
        filterParentDivRef.current &&
        !filterParentDivRef.current.contains(e.target)
      ) {
        setFilterOpen(false);
      }
    };

    document.addEventListener("click", handleFilter);

    return () => {
      document.removeEventListener("click", handleFilter);
    };
  }, [filterBGRef, filterRef]);

  useEffect(() => {
    if (label === "") {
      setCurrentCategory("");
    }
  }, [label]);

  useEffect(() => {
    if (ownerAccBalanceLoading) {
      UniversalRefreshToast();
    }
    if (!ownerAccBalanceLoading && !ownerAccBalanceError) {
      setTimeout(() => {
        toast.dismiss();
      }, IntervalConfiguration.intervalExtraSmall);
    }
  }, [ownerAccBalanceLoading]);

  useEffect(() => {}, [reimbursementRequestApprovalData]);
  const hasAccountApprovalAccess = services?.includes("AFieldForceRequest");
  const getTxnOverlayConfig = ({
    account,
    loading,
    openTxn,
    openAccountDrawer,
    openTxn2,
  }) => {
    const isError =
      account.lifecycle_status === "error" &&
      account.error === "true" &&
      !loading[account.request_id];

    const isRejected =
      account.lifecycle_status === "rejected" &&
      account.error === "false" &&
      !loading[account.request_id];

    const isAccountApprovalPending =
      account.lifecycle_status === "pending" &&
      account.field_force_account_approval_status === "pending" &&
      !loading[account.request_id];

    const isTxnApprovalPending =
      (account.lifecycle_status === "pending" || loading[account.request_id]) &&
      account.field_force_account_approval_status === "approved";

    if (isError) {
      return {
        cardState: "single",
        overlay1Icon: FailedToAction,
        overlay1Text: "Failed to take action",
        overlay1Subtext: account.message,
        overlay1CtaText: "View request",
        overlay1CtaOnClick: openTxn,
        overlay1Cta1Color: "var(--negative-act)",
        allowApproveReject: false,
      };
    } else if (isRejected) {
      return {
        cardState: "double",
        overlay1Icon: DeclinedRed,
        overlay1Text: "Rejected",
        overlay1Subtext: "This request has been rejected.",
        overlay1CtaText: "View request",
        overlay1CtaOnClick: openTxn,
        overlay2Text: account.rejection_reason,
        overlay2Subtext: "Rejected reason",
        allowApproveReject: false,
      };
    } else if (isAccountApprovalPending) {
      return {
        cardState: "single",
        overlay1Icon: null,
        overlay1Text: "Account approval pending",
        overlay1Subtext:
          "Account is not approved, please approve account before approving request.",
        overlay1CtaText: "Approve account",
        overlay1CtaOnClick: () => {
          if (hasAccountApprovalAccess) {
            openAccountDrawer();
          } else {
            navigate("/feature_not_assigned", {
              state: { unavailableService: "FFAAccount" },
            });
          }
        },

        allowApproveReject: false,
      };
    } else if (isTxnApprovalPending) {
      return {
        cardState: "default",
        allowApproveReject: services?.includes("AFieldForceRequest"),
      };
    } else {
      return {
        cardState: "default",
        allowApproveReject: false,
      };
    }
  };

  const OpenTimeline = async (id) => {
    SetopenTimelinePopup(true);
    // setShowApprovalTimeline(true);
    // dispatch(checkUsertoken());

    const details = await dispatch(getSpecificFieldForceRequest(id));

    if (details?.payload?.request) {
      let request = structuredClone(details.payload.request[0]);
      request.statusName =
        details.payload.request[0]?.lifecycle_status === "pending"
          ? "Require approval"
          : "pending";
      request.statusColor =
        details.payload.request[0]?.lifecycle_status === "pending"
          ? "text-pending"
          : "text-text-primary";

      setTimelineTxnDetails([request]);
    }
  };

  return (
    <>
      {!(
        noTransactionsFromAPI ||
        noResultsAfterFilter ||
        allBeneTxnAccountsLoading
      ) && (
        <div className="fixed w-full bottom-bottom-base z-z-index-tooltip">
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header"></div>
          )}
          <PaginationComponent
            handleSelect={handleSelect}
            selectedValue={selectedValue}
            data={mainData}
            pageSize={pageSize}
            dropdownOptions={dropdownOptions}
            handlePagination={handlePagination}
            currentPage={page}
            setIsOpen={setIsOpen}
          />
        </div>
      )}

      {opentimelinepopup && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <FieldForceReqTxnDetailsPopup
            field_force_request_id={RequestId}
            closePopup={() => {
              SetopenTimelinePopup(false);
            }}
            RequestHeader={"Request details"}
            type={"reimbursereq_details"}
            flow={"request_additional"}
          />
        </div>
      )}

      {openRequestpopup && (
        <div
          className="fixed top-top-base left-left-base w-full-width h-full-height z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={() => {
            setopenRequestpopup(false);
          }}
        >
          <FieldForceReqTxnDetailsPopup
            field_force_request_id={RequestId}
            closePopup={() => {
              setopenRequestpopup(false);
            }}
            RequestHeader={"Request details"}
            type={"reimbursereq_details"}
          />
        </div>
      )}

      {isDrawerOpen && (
        <div
          className="fixed top-top-base left-left-base w-full-width h-full-height z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={() => {
            closeBeneAccountDetailModal();
          }}
        >
          <FieldForceAccountDetailsPopup
            field_force_account_id={BeneTxnDetailsId}
            closeBeneAccountDetailModal={closeBeneAccountDetailModal}
            onSuccess={() => {
              onMount();
            }}
            // servicesType="BenAdmin"
          />
        </div>
      )}

      {showPopup && (
        <div className="fixed top-top-base left-left-base w-full h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
          {" "}
          <SmallPopupWithInput
            headerTitle={TEXT?.REJECT_REASON_REQ_TITLE}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            subtext={TEXT?.PROVIDE_REJECT_REQUEST_REASON_PROMPT}
            noteText={TEXT?.MINIMUM_TEN_CHARACTER_REQUIRED_MGS}
            isTextInputField={true}
            inputPlaceholder="Reason"
            inputFontKind="big"
            inputAdornment={false}
            subtextwithbullet="Y"
            bulletPoints={[
              "Once rejected, a new request should be created and no transaction will be initiated.",
              "The user needs to create a new request.",
            ]}
            inputVariant={
              declineReason &&
              declineReason?.length > GlobalConfiguration?.accountnormalLength
                ? "verified"
                : declineReason &&
                    declineReason.length <
                      GlobalConfiguration.owneraccountnormalLength
                  ? "typing"
                  : "default"
            }
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputIsFullWidth={true}
            btnOneText={TEXT.CANCEL}
            btnOneHandleFunction={() => {
              setCurrentBtnClicked((c) => {
                return {
                  ...c,
                  [deniedId]: "none",
                };
              });
              if (!showLoader) {
                handleClosePopup();
              }
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnOneIsDisabled={showLoader}
            btnTwoText={TEXT.REJECT}
            btnTwoHandleFunction={() => {
              if (
                !declineReason ||
                declineReason.length <
                  GlobalConfiguration.owneraccountnormalLength ||
                showLoader
              ) {
                return;
              }
              handleReject(deniedId, declineReason);
              handleClosePopup();
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !declineReason ||
              declineReason.length <
                GlobalConfiguration.owneraccountnormalLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={showLoader ? true : false}
            btnTwoIsLoading={showLoader ? true : false}
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}

      {showLoader && (
        <div className="fixed top-top-base left-left-base w-full h-full bg-PopUp-BackDrop bg-opacity-dark-opacity z-z-index-modal" />
      )}
      <div className="flex flex-col w-width-full h-screen bg-primary-bg pb-pagination-height">
        <div
          className={`w-width-full hidden Qsmd:block h-navbar-breadcrumb-height ${direction === "down" ? "bg-primary-bg" : "bg-primary-nav"} flex-shrink-0`}
        ></div>
        <div className="flex flex-col items-center justify-center shadow-box-shadow-bottom bg-primary-nav w-full-width z-z-index-overlay relative">
          <TopNavComponent
            direction={direction}
            topNavCtaBtn1Needed={false}
            topNavCtaBtn1Props={undefined}
            handleBack={() => navigate(GlobalConfiguration.navigate_back)}
            topNavCtaBtn2Needed={false}
            BottomHeader={undefined}
            isSelectionView={false}
            isToggleNeeded={true}
            toggleProps={{
              state: true,
              title: "Multi approval",
              isDisabled: showSearchBar,

              handleClick: () => {
                setDirection("");
                navigate(
                  "/field_force_transaction_dashboard/field_force_request_multi_approval",
                );
              },
            }}
            assignLabelNeeded={false}
            assignTagNeeded={false}
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: allBeneTxnAccountsLoading,
              onSearchInput: (val) => setSearchUserTextDebounce(val),
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search request",
              filterPlaceholder: "Category / Labels",
              filterItems: [
                {
                  name: "Category",
                  short_name: "Cat",
                  isMulti: false,
                  value: currentCategory,
                  setValue: (val) => {
                    const selectedCategory = inputData.find(
                      (category) =>
                        String(category?.id) === String(val) ||
                        category?.Category === val,
                    );
                    const categoryId = selectedCategory?.id ?? val;
                    const categoryName = selectedCategory?.Category ?? "";
                    setPage(GlobalConfiguration.lengthCheckOne);
                    setCurrentCategory(categoryId);
                    setDisplayCategory(categoryName);
                    const params = new URLSearchParams(window.location.search);
                    params.delete("category");
                    params.set("category_id", String(categoryId));
                    if (categoryName) {
                      params.set("dispCat", categoryName);
                    } else {
                      params.delete("dispCat");
                    }
                    params.set(
                      "pageno",
                      String(GlobalConfiguration.lengthCheckOne),
                    );
                    navigate(
                      {
                        pathname: location.pathname,
                        search: `?${params.toString()}`,
                      },
                      { replace: true },
                    );
                  },
                  isDropdown: true,
                  displayValue: displayCategory,
                },
              ],
              isSearchClearAllDisabled: !currentCategory?.length,
              inputData: inputData,
              active: active,
              setActive: setActive,
              loading: allBeneTxnAccountsLoading,
              loadingData: loadingData,
              setLoading: setLoadingData,
              isShowSortBy: false,
              isShowFilter: false,
            }}
          />
        </div>

        <div className="flex-1 overflow-y-auto overflow-x-hidden w-width-full flex justify-center pb-padding-xl Qsmd:pb-padding-base relative">
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header"></div>
          )}
          <div
            className="flex flex-col gap-gap-md py-padding-md w-width-full px-padding-md Qlg:px-padding-base overflow-y-auto"
            onScroll={handleScroll}
          >
            {allBeneTxnAccountsLoading ? (
              <div className="w-width-full  h-full flex items-center justify-center">
                <Loader />
              </div>
            ) : noTransactionsFromAPI ? (
              <div className="w-full flex flex-col items-center justify-center text-center gap-gap-md m-auto">
                <div>
                  <img
                    src={ICONS?.NO_PENDING_TRANSACTION}
                    alt="no-pending-transaction"
                  />
                </div>
                <p className="text-sm text-text-primary">
                  There are no more transactions that require <br /> your
                  approval.
                </p>
                <PrimaryButton
                  enabledBgColor="var(--primary-nav-act)"
                  btnText="Go to dashboard"
                  hoverOption="white"
                  btnType="button"
                  handleFunction={() =>
                    navigate("/field_force_transaction_dashboard")
                  }
                  enabledTextColor="var(--text-primary)"
                />
              </div>
            ) : noResultsAfterFilter ? (
              <div className="w-full flex flex-col items-center justify-center text-center gap-gap-md m-auto">
                <div>
                  <img
                    src={ICONS?.NO_DATA_FOUND}
                    alt="no data found"
                  />
                </div>
                <p className="text-sm text-text-primary">No data found.</p>
                <PrimaryButton
                  enabledBgColor="var(--primary-nav-act)"
                  btnText="Clear parameters"
                  hoverOption="white"
                  btnType="button"
                  handleFunction={() => {
                    handleClearFilters();
                  }}
                  enabledTextColor="var(--text-primary)"
                />
              </div>
            ) : (
              reimbursementRequestApprovalData === undefined ||
              AllReimburseTxnAccounts?.map((account) => {
                const overlay = getTxnOverlayConfig({
                  account,
                  loading,
                  openTxn: () => {
                    setopenRequestpopup(true);
                    setRequestId(account?.request_id);
                  },
                  openAccountDrawer: () =>
                    SideDrawerOpen(
                      account.field_force_account_id,
                      account.request_id,
                    ),
                });

                const alerts = [];

                /**
                 * @type {import("../../../components/_utils/CommonTransactionApprovalCard/index.jsx").Entry[][]}
                 */
                const entries = [
                  [
                    {
                      type: "textSubtext",
                      text: `INR ${FormatAmount({ price: account?.requested_amount || "0" })}`,
                      subText: "Amount",
                      textColor: "var(--settled)",
                      isBold: true,
                    },
                    {
                      type: "textSubtext",
                      text: account?.field_force_account_name,

                      subText: "Account name",
                    },
                    {
                      type: "textSubtext",
                      text:
                        account?.category_id?.category_name || "unavailable",
                      subText: "Category",
                    },
                  ],
                ];

                return (
                  <div
                    key={account.txn_id}
                    className="mx-auto flex Qlg:flex-row flex-col Qlg:max-w-[var(--tab-width-normal)] w-width-full z-z-index-content"
                  >
                    <CommonTransactionApprovalCard
                      overrideAutoLoader
                      whichBtnClicked={
                        currentBtnClicked?.[account.request_id] ?? "none"
                      }
                      accountApprovalPending={
                        account.lifecycle_status === "pending" &&
                        account.field_force_account_approval_status ===
                          "pending" &&
                        !loading[account.txn_id]
                      }
                      entries={entries}
                      alerts={alerts}
                      cardState={overlay.cardState}
                      overlay1Text={overlay.overlay1Text}
                      overlay1SubtextColor={
                        account.field_force_account_approval_status ===
                        "pending"
                          ? "var(--pending)"
                          : "var(--text-primary)"
                      }
                      overlay1Subtext={overlay.overlay1Subtext}
                      overlay1CtaText={overlay.overlay1CtaText}
                      overlay1CtaOnClick={overlay.overlay1CtaOnClick}
                      overlay1Cta1Color={overlay?.overlay1Cta1Color}
                      overlay2Text={overlay.overlay2Text}
                      overlay2Subtext={overlay.overlay2Subtext}
                      approveClick={() => {
                        if (services?.includes("AFieldForceRequest")) {
                          const updatedAccountDetails = {
                            request_id: account?.request_id,
                            bankAccountName: account?.field_force_account_name,
                            beneAccountId: account?.field_force_account_id,
                            bankAccountIFSC:
                              account?.field_force_account_ifsc_code,
                            bankAccountNo:
                              account?.field_force_account_bank_acc_no,
                            categories: account?.category_id?.category_name,
                            categoryId: account?.category_id?.category_id,
                            requested_amount: account?.requested_amount,
                            settleType: account?.payment_method || "IMPS",
                            bankLogo: account?.field_force_account_ifsc_code,
                            pan: account?.pan || "",
                            ownerId: null,
                            ownerAccountName: "",
                            ownerBankIFSC: null,
                            ownerBankBalance:
                              GlobalConfiguration.lengthCheckZero,
                            ownerBankLogo: null,
                            ownerLastUpdated: null,
                            ownerBankAccountNo: null,
                            selectedCategory: {
                              configuration: account?.additional_data,
                            },
                            mergeCategory: account?.additional_data?.data,
                            amountInWords: "",
                            labels: account?.labels || [],
                            ownerLabels: [],
                            comment: account?.comment || "",
                            date: account?.created_on,
                            expenseType: account?.expense_type || "",
                            description: account?.description || "",
                            uploadFile: account?.uploaded_file_data || "",
                            uploadURL: account?.uploaded_file_url || "",
                          };

                          setcurrentAccountDetails(updatedAccountDetails);

                          navigate(
                            "/field_force_transaction_dashboard/create_field_force_transaction",
                            {
                              state: {
                                ...updatedAccountDetails,
                                type: "PayFieldForceTxn",
                                flow: "PayFieldForceTxn",
                                TypeRTGS: "RequestRTGS",
                              },
                            },
                          );
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "AFieldForceRequest",
                            },
                          });
                        }
                      }}
                      rejectClick={() => {
                        setCurrentBtnClicked((c) => {
                          return { ...c, [account.request_id]: "reject" };
                        });

                        if (hasAccountApprovalAccess) {
                          handleOpenPopup(account.request_id);
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "AFieldForceRequest",
                            },
                          });
                        }
                      }}
                      approveBtnText="Approve and pay"
                      rejectBtnText={
                        <>
                          Reject
                          <br />
                          request
                        </>
                      }
                      DestinationNotRequired={true}
                      createdByRequired={true}
                      createdOnSubtext={"Created on"}
                      createdOnText={account?.created_on}
                      createdByText={account?.created_by_name}
                      createdOnRequired={true}
                      destinationAccountNumber={
                        account?.field_force_account_bank_acc_no
                      }
                      destinationAccountIfsc={
                        account?.field_force_account_ifsc_code
                      }
                      destinationAccountNumberSubtext="Destination account"
                      destinationAccountText={
                        account?.field_force_account_ifsc_code
                      }
                      destinationAccountSubtext="IFSC"
                      ctaBtn1Text="More details"
                      ctaBtn1OnClick={() => {
                        setopenRequestpopup(true);
                        setRequestId(account?.request_id);
                        // CommonToast({
                        //   text: "Feature coming soon",
                        //   icon: ICONS?.INFO,
                        //   variant: "var(--coming-soon)",
                        //   buttonNeeded: false,
                        // });
                      }}
                      // ctaBtn2Text="Additional details"
                      // ctaBtn2OnClick={() => {
                      //   setRequestId(account?.request_id);
                      //   OpenTimeline(account?.request_id);
                      // }}
                      overlay1Icon={overlay.overlay1Icon}
                      overlay1IconColor={overlay.overlay1IconColor}
                    />
                  </div>
                );
              })
            )}
          </div>
        </div>
        <div
          className={`h-pagination-height ${showInnerSearchBar ? "hidden " : " hidden Qsmd:block"} w-width-full `}
        ></div>
      </div>
    </>
  );
};

export default FieldForceRequestSingleApproval;
